import {gql} from "@apollo/client";

export const CHECK_AUTH_FOR_HEADER = gql`
    query CheckAuthForHeader {
        isAuth @client(always: true)
    }
`;
